import { Directive, input } from '@angular/core';

import { fullName } from '@camelot/utils';

import { IEvent } from '../../types/event';

export type EventDuration = 'short' | 'medium' | 'long';

@Directive()
export abstract class CamAbstractrEventCardComponent {
  event = input.required<IEvent>();

  public fullName = fullName;

  get eventDurationClass(): string {
    return `event-card--${this.eventDuration}`;
  }

  get eventDuration(): EventDuration {
    const event = this.event();
    if (!event?.startDate || !event?.endDate) {
      return 'short';
    }

    const start = new Date(event.startDate);
    const end = new Date(event.endDate);
    const durationInHours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);

    if (durationInHours < 1) {
      return 'short';
    } else if (durationInHours <= 2) {
      return 'medium';
    } else {
      return 'long';
    }
  }
}
